import React from "react";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import StatusChip from "../location/StatusChip";

import {
  MEDIA_THUMBNAIL_URL,
  PLACEHOLDER_IMG_120x120_URL,
  PLACEHOLDER_IMG_120x120_ERROR_URL,
  IMG_BG_COLOR
} from "../../config";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    marginTop: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1)
  },
  img: {
    width: 70,
    height: 75,
    margin: "auto",
    objectFit: "contain",
    backgroundColor: IMG_BG_COLOR
  }
}));

export default function InfoWindowLoc({
  title,
  titleLink,
  detail,
  mediaId,
  status,
  buttonLabel,
  handleClick,
  selectedIndex
}) {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Grid container spacing={2}>
        <Grid item>
          <img
            className={classes.img}
            alt=""
            src={
              !!mediaId
                ? `${MEDIA_THUMBNAIL_URL}/${mediaId}?width=120`
                : PLACEHOLDER_IMG_120x120_URL
            }
            onError={e => {
              e.target.onerror = null;
              e.target.src = PLACEHOLDER_IMG_120x120_ERROR_URL;
            }}
          />
        </Grid>
        <Grid item xs={12} sm container>
          <Grid
            item
            xs
            container
            direction="column"
            style={{ maxWidth: "200px" }}
          >
            <Grid item xs>
              <Link
                color="inherit"
                href={titleLink}
                target="_blank"
                underline="none"
                variant="body2"
              >
                {title}
              </Link>

              <Divider light />
              <Typography variant="caption" color="textSecondary">
                {detail}
              </Typography>
              <StatusChip status={status} />
            </Grid>
            {!!handleClick && (
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                size="small"
                onClick={() => handleClick(selectedIndex)}
              >
                {buttonLabel}
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
